import "./homeStyles.css";
import { useNavigate } from "react-router";
import { BigPicture } from "./components/BigPicture";
import { ImageTextButton } from "./components/ImageTextButton";
import { FourImagesGrid } from "./components/FourImagesGrid";
import { ToPortfolio } from "./components/ToPortfolio";
import { DescriptionText } from "./components/DescriptionText";

export const Home = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-black pb-20 text-white">
      <div className="mx-auto flex max-w-7xl flex-col overflow-hidden">
        <BigPicture />
        <DescriptionText />
        <ImageTextButton navigate={navigate} />
        <img
          className="mt-10 w-full md:px-20"
          src={
            "/photos/home/full_width_middle_picture/full_width_middle_picture.jpg"
          }
          alt="logo"
          loading="lazy"
        />
        <FourImagesGrid />
        <ToPortfolio navigate={navigate} />
      </div>
    </div>
  );
};
